import { ScheduledQuery } from '@api';
import { t } from 'i18next';

export const formatCadence = (cadence: ScheduledQuery['cadence']): string =>
  [
    t(`chat:scheduledQuerySettings.frequencyOptions.${cadence.frequency}`),
    cadence.day_of_week &&
      t(`chat:scheduledQuerySettings.dayOptions.${cadence.day_of_week}`),
    t(`chat:scheduledQuerySettings.deliveryTimeOptions.${cadence.time_window}`),
  ]
    .filter(Boolean)
    .join(' · ');

export const getWebSearchLabel = (
  webSearch: string | { sources: string[] } | undefined,
  isBlocked = false
): string => {
  if (isBlocked || webSearch === 'block') {
    return t('chat:trustedSources.block.title');
  }
  if (webSearch === 'restricted') {
    return t('chat:trustedSources.restricted.title');
  }
  if (typeof webSearch === 'object' && webSearch !== null) {
    return webSearch.sources.length > 0
      ? t('chat:trustedSources.restricted.title')
      : t('chat:scheduledTaskDetail.generalWebSearch');
  }
  return t('chat:scheduledTaskDetail.generalWebSearch');
};

export const formatModalCadence = (task: ScheduledQuery): string => {
  const toolsConfig = task.request?.tools_config;
  const isBlocked = toolsConfig?.group_filter?.policy === 'Block';
  const webSearch = getWebSearchLabel(
    toolsConfig?.parameters?.web_search,
    isBlocked
  );
  const cadence = formatCadence(task.cadence);
  return webSearch ? `${webSearch}  |  ${cadence}` : cadence;
};
